module.exports = __webpack_public_path__ + "img/05_check_2.bf7a5576.svg";